import React from 'react';
import { Route } from 'react-router-dom';

const WrappedRoute = ({ component: Com, ...args }) => (
  <Route {...args} render={(props) => <Com {...{ ...args, ...props }} />} />
);

export default WrappedRoute;
